// extracted by mini-css-extract-plugin
module.exports = {"new-task-title-input":"Input-c7c5fea64e4b9a7f1bb4d625f7663675","newTaskTitleInput":"Input-c7c5fea64e4b9a7f1bb4d625f7663675"};